<template >
<div id="paymentHistory">
  <div v-if="loading">
    <h2 class="text-center">Loading...</h2>
  </div>
  <div class="row" v-else-if="nothingToShow !=''">
  <div class="col text-center">
  <h3>{{nothingToShow}}</h3>
  </div>
</div>
<div class="container fluid" v-else-if="isLoaded && user.authenticated">
  <div>
<div class="row">
<div class="col-md-6">
<h2>General</h2>
<p>
<span>Opened:</span> {{paymenthistory.openedDate | moment('MM-DD-YYYY')}}<br>
<span v-if="paymenthistory.advancePaymentFlag">Advance Payment:</span><span v-else>Security Deposit:</span> {{paymenthistory.securityDeposit | currency}}
</p>
<p>
<span>Contract Payments Made:</span> {{paymenthistory.paymentsMade}}<br>
<span>Total Amount Paid:</span> {{paymenthistory.amountPaid | currency }}
</p>
<p>
<span>Contract Payments Remaining:</span> {{paymenthistory.paymentsRemaining}}<br>
<span>Payoff Amount:</span> {{paymenthistory.amountRemaining}}
</p>
</div>
</div></div>
<div class="row">
<div class="col-auto mr-auto"></div>
<div class="col-auto" style="margin-bottom:20px;"><b-btn class="btn btn-primary" v-b-modal="modalWire(parentData)"  lazy>Wire Instructions</b-btn></div>
<div class="col-auto" style="margin-bottom:20px;"><b-btn class="btn btn-primary" v-b-modal="modalPayoff(parentData)" v-on:click="sendRequest" :messageresult="this.message" lazy>Request Payoff</b-btn>
</div>
<div>
</div>
</div>
<div class="row">
<div class="col-md-12">
<div class="overflow-auto">
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <p class="mt-3">Current Page: {{ currentPage }}</p>

    <b-table
      id="my-table"
      striped
      hover
      fixed
      bordered
      :items="paymenthistory.history"
      :fields='tableFields'
      :per-page="perPage"
      :current-page="currentPage"
    ></b-table>
  </div>
</div>
</div>
<div class="row">
  <div class="col-md-12">
    <p>* indicates NSF payment that went through</p>
    </div>
  </div>
</div>
<div class="row" v-else>
  <div class="col text-center">
  <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
  </div>
</div>

</div>
</template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalHistory',
  props: {
    parentData: {
      type: Number
    }
  },
  data: function () {
    return {
      loading: false,
      object: [],
      paymenthistory: {
        history: [],
        delinquent_Days: {
          0: {
            amount: 0
          },
          1: {
            amount: 0
          },
          2: {
            amount: 0
          },
          3: {
            amount: 0
          },
          4: {
            amount: 0
          },
          5: {
            amount: 0
          }
        }
      },
      history: [],
      message: true,
      messageresult: '',
      user: auth.user,
      perPage: 10,
      currentPage: 1,
      tableFields: [
        {
          key: 'datePaid',
          label: 'Date',
          formatter: value => {
            return this.$moment(value).format('MM-DD-YYYY')
          },
          sortable: true
        },
        {
          key: 'description',
          label: 'Description',
          sortable: false
        },
        {
          key: 'amountPaid',
          label: 'Amount',
          formatter: value => {
            return this.$options.filters.currency(value)
          },
          sortable: false
        }
      ],
      nothingToShow: '',
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
    modalWire (key) {
      return 'modalWireInstructions' + key
    },
    modalPayoff (key) {
      return 'modalRequestPayoff' + key
    },
    sendRequest () {
      let uri = this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/paymenthistory/requestpayoff'
      axios.post(uri, '', {headers: auth.getAuthHeader()}).then((response) => {
        this.message = true
        this.$emit(this.messageresult, this.message)
      }).catch(() => {
        this.message = false
        this.$emit(this.messageresult, this.message)
      })
    }
  },
  mounted: async function () {
    this.loading = true
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/paymenthistory', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.paymenthistory = Object.freeze(response.data)
        console.log(response)
        if (response.status === 200) {
          console.log(response.status)
          this.loading = false
        } else {
          console.log(response.status)
        }
      })
      .catch((error) => {
        console.error('An error occurred:', error)
        if (error.response) {
          console.error('Response data:', error.response.data)
          console.error('Response status:', error.response.status)
          console.error('Response headers:', error.response.headers)
        } else if (error.request) {
          // The request was made, but no response was received
          console.error('Request data:', error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Error message:', error.message)
        }
        this.loading = false
        this.nothingToShow = 'Sorry there is no history to display at this time.'
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('paymenthistory') &&
      this.paymenthistory != null) {
        return true
      }
      return false
    },
    deliquentTotal: function () {
      let total = 0
      if (this.paymenthistory.delinquent_Days) {
        for (let i = 0; i < this.paymenthistory.delinquent_Days.length; i++) {
          total += this.paymenthistory.delinquent_Days[i].amount
        }
      }
      return total
    },
    rows: function () {
      return this.paymenthistory.history.length
    }
  }
}
</script>

<style>
#paymentHistory span {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/modalHistory.vue